<script>
import AdminSideBar from '@/commons/admin-sidebar-menu';
import SidebarMenuItem from './SidebarMenuItem.vue';
import {mapState} from 'vuex';
import _ from 'lodash';
import helper from "../../commons/helper";

export default {
  name: 'SideBar',
  components: {SidebarMenuItem},
  data() {
    const settings = JSON.parse(localStorage.getItem('loginSettings'));
    return {
      sidebars: {},
      portal: settings.portal,
      unitId: settings.unitId ? settings.unitId : '',
      vendorId: settings.vendorId ? settings.vendorId : '',
      prefixCode: settings.prefixCode,
      customerName: settings.customerName ? settings.customerName : '',
      reservationNumber: settings.reservationNumber ? settings.reservationNumber : '',
      reservationStatus: ''
    };
  },
  computed: {
    ...mapState({
      accountInformation: state => state.common.accountInformation,
      reservationDetails: state => state.common.reservationDetails
    })
  },
  watch: {
    '$route'() {
      const settings = JSON.parse(localStorage.getItem('loginSettings'));
      this.sidebars = AdminSideBar[settings.portal];
      this.portal = settings.portal;
      this.unitId = settings.unitId;
      this.vendorId = settings.vendorId;
      this.reservationNumber = settings.reservationNumber;
    }
  },
  mounted() {
    const settings = JSON.parse(localStorage.getItem('loginSettings'));
    this.sidebars = AdminSideBar[settings.portal];
    if (settings.portal === 'owner') {
      const settingStatements = this.$store.state.common.accountInformation.owner.loginOptions.allowStatements;
      const settingBookings = this.$store.state.common.accountInformation.owner.loginOptions.allowBookings;
      const settingRent = this.$store.state.common.accountInformation.owner.loginOptions.showOwnerMoney;
      _.each(this.sidebars, function(item) {
        if (item.name === 'Statements') {
          item.active = settingStatements;
        }
        if (item.name === 'Book Unit') {
          item.active = settingBookings;
        }
        if (item.name === 'Rent/Nights') {
          item.active = settingRent;
        }
      });
    } else if (settings.portal === 'reservation') {
      // Only enable Payments if the reservation accepts payments
      this.reservationStatus = this.$store.state.common.reservationDetails.bookingStatus;
      _.each(this.sidebars, (item) => {
        if (item.name === 'Make A Payment') {  // :KLUDGE: RJW - This is _very_ brittle as the JSON can change
          item.active = (helper.BookingStatus.paymentsAllowed(this.reservationStatus));
        }
      });
    }
  }
};
</script>

<template>
  <div>
    <div v-if="accountInformation && accountInformation.unit" class="base-infor">
      <div class="resort-name">
        {{accountInformation.unit.localAddress}}
      </div>
      <div class="unit-id text-uppercase">
        {{unitId}}
      </div>
      <div class="user-name">
        {{accountInformation.owner.name}}
      </div>
    </div>
    <div v-if="accountInformation && accountInformation.vendor" class="base-infor">
      <div v-if="accountInformation.vendor" class="resort-name">
        {{accountInformation.vendor.name}}
      </div>
      <div class="unit-id text-uppercase">
        {{vendorId}}
      </div>
      <div class="user-name">
        {{accountInformation.vendor.contact}}
      </div>
    </div>
    <div v-if="reservationDetails" class="base-infor">
      <div class="resort-name text-uppercase">
        {{customerName}}
      </div>
      <div v-if="reservationNumber" class="unit-id text-uppercase">
        {{'#' + reservationNumber}}
        <span v-if="reservationStatus">
          &nbsp;&nbsp;({{reservationStatus}})
        </span>
      </div>
      <div class="user-name">
        {{reservationDetails.name}}
      </div>
    </div>
    <div class="nav-menu">
      <ul class="list-unstyled">
        <SidebarMenuItem v-for="(item, index) in sidebars" :key="index" :item="item" />
        <li>
          <a class="menu-item cursor-pointer" @click="$helper.logout()">
            <div class="menu-content">
              <img src="/img/logout.png">
              <span>Logout</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
.base-infor {
  color: #c79c33;
  font-size: 16px;
  line-height: 28px;
  padding: 40px 45px 40px;

  .resort-name {
    font-size: 22px;
    line-height: 34px;
    margin-bottom: 10px;
  }

  .unit-id {
    margin-bottom: 5px;
  }

  .user-name {
    font-family: AvenirLTStd BookOblique, sans-serif;
  }
}
</style>
